import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalCCDelete(props) {
    const {
        contactModalDeleteString,
        contactMDNameString,
        contactMDEmailString,
        contactMDClientString,
        contactMDEDateString,
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    var deleteContactName = localStorage.getItem("contactNameToDelete");
    var deleteContactEmail = localStorage.getItem("contactEmailToDelete");
    var deleteContactBusiness = localStorage.getItem("contactBusinessToDelete");
    var deleteContactCreatedDate = localStorage.getItem("contactCreatedDateToDelete");

    var deleteContactId = localStorage.getItem("contactIdToDelete");

    function deleteContact() {
        customAxios.request({
            url: `${GlobalVariables.getURL()}deleteCont/${deleteContactId}`,
            method: 'delete',
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then((response) => {
            console.log(response.data)
            hideS();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al eliminar contacto. Vuelve a intentarlo.' });
        });
    } 

    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Contacto eliminado exitosamente en la base de datos.' });
        let endpoint = `${GlobalVariables.getURL()}listClientsContacts`;
        if (props.selectedClients.length > 0) {
            endpoint += `?id=${props.selectedClients}`;
        }
        props.getContacts(endpoint);
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {contactModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{contactMDNameString}:</strong> {deleteContactName}</span><br />
                <span className='delete-info'><strong>{contactMDEmailString}:</strong> {deleteContactEmail}</span><br />
                <span className='delete-info'><strong>{contactMDClientString}:</strong> {deleteContactBusiness}</span><br />
                <span className='delete-info'><strong>{contactMDEDateString}:</strong> {deleteContactCreatedDate}</span>
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteContact()}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalCCDelete;